
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m1-002",
      function () {
        return require("private-next-pages/m1-002.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m1-002"])
      });
    }
  